import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  accent?: "primary" | "accent" | "secondary";
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  accent = "primary",
}: SectionHeadingProps) {
  const barClass =
    accent === "accent" ? "bg-accent-500" : accent === "secondary" ? "bg-secondary-500" : "bg-primary-500";

  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className={`h-6 w-1.5 rounded-full ${barClass}`}></span>
        <div>
          <h2 className="text-xl font-bold text-foreground-50 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex flex-shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-400 transition-colors hover:text-primary-400"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}